// const pdfjsLib = require("pdfjs-dist/legacy/build/pdf.js");

const btn = document.getElementById('pdfjs-view');
// pdfjsLib.GlobalWorkerOptions.workerSrc = btn.dataset.worker;

// var pdfDoc = null,
//     pageNum = 1,
//     pageRendering = false,
//     pageNumPending = null,
//     scale = 0.8,
//     canvas = document.getElementById('the-canvas'),
//     ctx = canvas.getContext('2d');

// /**
//  * Get page info from document, resize canvas accordingly, and render page.
//  * @param num Page number.
//  */
// function renderPage(num) {
//   pageRendering = true;
//   // Using promise to fetch the page
//   pdfDoc.getPage(num).then(function(page) {
//     var viewport = page.getViewport({scale: scale});
//     canvas.height = viewport.height;
//     canvas.width = viewport.width;

//     // Render PDF page into canvas context
//     var renderContext = {
//       canvasContext: ctx,
//       viewport: viewport
//     };
//     var renderTask = page.render(renderContext);

//     // Wait for rendering to finish
//     renderTask.promise.then(function() {
//       pageRendering = false;
//       if (pageNumPending !== null) {
//         // New page rendering is pending
//         renderPage(pageNumPending);
//         pageNumPending = null;
//       }
//     });
//   });

//   // Update page counters
//   document.getElementById('page_num').textContent = num;
// }

// /**
//  * If another page rendering in progress, waits until the rendering is
//  * finised. Otherwise, executes rendering immediately.
//  */
// function queueRenderPage(num) {
//   if (pageRendering) {
//     pageNumPending = num;
//   } else {
//     renderPage(num);
//   }
// }

// /**
//  * Displays previous page.
//  */
// function onPrevPage() {
//   if (pageNum <= 1) {
//     return;
//   }
//   pageNum--;
//   queueRenderPage(pageNum);
// }
// document.getElementById('prev').addEventListener('click', onPrevPage);

// /**
//  * Displays next page.
//  */
// function onNextPage() {
//   if (pageNum >= pdfDoc.numPages) {
//     return;
//   }
//   pageNum++;
//   queueRenderPage(pageNum);
// }
// document.getElementById('next').addEventListener('click', onNextPage);

btn.addEventListener('click', () => {
  /**
   * Asynchronously downloads PDF.
   */
  // pdfjsLib.getDocument(btn.dataset.pdf).promise.then(function(pdfDoc_) {
  //   pdfDoc = pdfDoc_;
  //   document.getElementById('page_count').textContent = pdfDoc.numPages;

  //   // Initial/first page rendering
  //   renderPage(pageNum);
  // });
  document.querySelector('.adv-pdf-modal--outer').classList.add('show');
});

document.querySelector('.adv-modal--close').addEventListener('click', function() {
  document.querySelector('.adv-pdf-modal--outer').classList.remove('show');
});

let isMouseHover = false
document.querySelector('.adv-pdf-modal--window').addEventListener('mouseover', function() {
  isMouseHover = true;
});

document.querySelector('.adv-pdf-modal--window').addEventListener('mouseleave', function() {
  isMouseHover = false;
});

document.querySelector('.adv-pdf-modal--outer').addEventListener('click', function() {
  if (!isMouseHover) {
    document.querySelector('.adv-pdf-modal--outer').classList.remove('show');
  }
});
